import { render, staticRenderFns } from "./CustomFieldGeneratorComponent.vue?vue&type=template&id=52016afa&scoped=true&lang=pug"
import script from "./CustomFieldGeneratorComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldGeneratorComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldGeneratorComponent.vue?vue&type=style&index=0&id=52016afa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52016afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52016afa')) {
      api.createRecord('52016afa', component.options)
    } else {
      api.reload('52016afa', component.options)
    }
    module.hot.accept("./CustomFieldGeneratorComponent.vue?vue&type=template&id=52016afa&scoped=true&lang=pug", function () {
      api.rerender('52016afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/customFieldsPlayground/CustomFieldGenerator/CustomFieldGeneratorComponent.vue"
export default component.exports